export enum NavLinkType {
  EXTERNAL,
  INTERNAL,
}
